module.exports = __webpack_public_path__ + "static/media/deepika_goyal.9ed16a25.jpeg";